// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_ICSS_IMPORT_0___ from "-!../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].use[1]!./colors.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("styles/img/icon_down.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("styles/img/icon_remove.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("styles/img/dropdown.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.helpers__errorWrapper___YO9B9 {
  border-left: 3px solid #a13739;
  padding-left: 10px;

  label {
    color: #a13739;
  }
}

.helpers__card___Gg3yG {
  border: 1px solid rgba(73, 80, 84, 0.15);
  border-radius: 4px;
  box-shadow: 0 1px 2px 0 rgba(58, 64, 68, 0.08);
}

.helpers__cardMarginBot___X0aML {
  margin-bottom: 20px;
}

.helpers__input___Qys3C {
  background: white;
  border: 1px solid ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGray"]};
  border-radius: 3px;
  height: 42px;
  line-height: 42px;
  padding: 0 0.75rem;
  transition: all 0.25s;
  width: 100%;
  font-weight: 500;

  &::placeholder {
    opacity: 0.5;
  }

  &:focus {
    background: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtBlueLight"]};
    border: 1px solid ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtBlue"]};
    outline: none;
  }

  &:not(:placeholder-shown) {
    font-weight: 700;
  }
}

.helpers__label___cektH {
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["textLight"]};
  cursor: pointer;
  display: inline-block;
  font-size: 12px;
  margin-bottom: 3px;
}

.helpers__select___atjcE {
  -webkit-appearance: none;
  background-color: white;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-position: right 15px center;
  background-repeat: no-repeat;
  border: 1px solid ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGray"]};
  border-radius: 3px;
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtBlue"]};
  cursor: pointer;
  display: inline-block;
  height: 42px;
  padding: 0 0.75rem;
  width: 100%;
  font-weight: 500;

  &:focus {
    background-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtBlueLight"]};
    border: 1px solid ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtBlue"]};
    outline: none;
  }

  &:not(:focus) {
    background-color: white !important;
  }

  &:has(option:checked:not([value])),
  &:has(option:checked:not([value=''])) {
    color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["text"]} !important;
    font-weight: 700;
  }
  &:disabled {
    cursor: not-allowed;
    color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGrayDark"]} !important;
    background: #e1e1e178 !important;
    border: 1px solid rgba(195, 195, 195, 0.45);
  }
}

.helpers__clearfix___NGtVZ::after {
  clear: both;
  content: '';
  display: table;
}

.helpers__content-container___ib8em {
  lost-center: 1440px 20px;
  padding: 20px;
}

.helpers__row___plfhc {
  align-items: center;
  float: none;
  lost-flex-container: row;
  lost-utility: clearfix;
}

.helpers__rowTop____WU6A {
  float: none;
  lost-flex-container: row;
  lost-utility: clearfix;
}

.helpers__halfLeft___v4YHP {
  justify-content: flex-start;
  lost-column: 1/2;
  text-align: left;
}

.helpers__halfRight___qgGju {
  justify-content: flex-end;
  lost-column: 1/2;
  text-align: right;
}

/* Buttons */

.helpers__button___UMeeN {
  background: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtBlue"]};
  border: none;
  border-radius: 3px;
  box-shadow: none;
  color: white;
  cursor: pointer;
  display: inline-block;
  font-size: 15px;
  font-weight: 700;
  height: 48px;
  line-height: 48px;
  padding: 0 1.5em;
  text-decoration: none;
  text-shadow: none;
  transition: all 0.25s;
  width: auto;

  &:disabled {
    opacity: 0.4;

    &:hover {
      opacity: 0.4;
    }
  }

  &:hover {
    background: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtBlueDark"]};
    box-shadow: none;
  }

  &:active,
  &:focus {
    background: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtBlueDark"]};
    border: none;
  }

  &:first-child {
    margin-left: 0;
  }
}

.helpers__buttonSecondary___ji2f0 {
  background: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGray"]};
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtBlue"]};
  /* padding-top: 12px; */
  padding-bottom: 12px;

  &:hover {
    background: #e1dfe1;
  }

  &:active,
  &:focus {
    background: #e1dfe1;
  }
}

.helpers__buttonDanger___rKFYv {
  background: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtRed"]};

  &:active,
  &:focus,
  &:hover {
    background: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtRedDark"]};
  }
}

.helpers__buttonLocal___p_fq2 {
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGreen"]};
  padding-top: 0 !important;
}

.helpers__buttonLocalActive___S9s2m {
  background: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGreen"]};
  color: white;
}

.helpers__addButton___qCRqP {
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGreen"]};
  cursor: pointer;
  display: inline-block;
  background: none;
  font-weight: 600;
  border-radius: 3px;
  padding: 0 1.5em;
  border: 2px solid ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGreen"]};
  height: 42px;
  line-height: 38px;
  transition: background 0.2s;

  &:hover {
    background: #f8f8f8;
  }
}

.helpers__dropzoneArea___G6f3s {
  cursor: pointer;
  background: none;
  width: 100%;
  font-weight: 500;
  border: 2px dashed rgba(58, 64, 68, 0.2);
  border-radius: 3px;
  text-align: center;
  line-height: 80px;
  height: 80px;
  transition: all 0.25s;
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["textLight"]};

  &:hover {
    background: #f8f8f8;
    border: 2px dashed rgba(58, 64, 68, 0.4);
  }
}

.helpers__docLink___FASgd {
  margin-left: 32px;
  position: relative;
}

/* Section styles */

.helpers__boxWrap___tA8T7,
.helpers__section___r3JJf {
  background: white;
  border-radius: 3px;
  margin: 0 0 20px;
  padding: 20px;
  width: 100%;
}

.helpers__sectionNoMargin___JiDIG {
  background: white;
  border-radius: 3px;
  padding: 20px;
  width: 100%;
}

.helpers__sectionSmall___nou05 {
  background: white;
  border-radius: 3px;
  margin-bottom: 1px;
  padding: 20px;
  width: 100%;
}

.helpers__errorText___iCO0x {
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtRed"]};
}

.helpers__errors____e8HD {
  color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtRed"]};
  margin-bottom: 20px;

  h5,
  h6 {
    color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtRed"]};
  }
}

.helpers__sectionLarge___tGucQ {
  background: white;
  border-radius: 3px;
  margin-bottom: 40px;
  padding: 20px;
  width: 100%;
}

.helpers__sectionTitle___pCNpO {
  align-items: center;
  background: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtCardHeaderBG"]};
  border-radius: 4px 4px 0 0;
  box-shadow: 0 1px 0 0 rgba(58, 64, 68, 0.1);
  display: flex;
  height: 50px;
  margin-bottom: 1px;
  padding: 0 20px;
  width: 100%;
}

.helpers__form___SDgsR {
  lost-flex-container: column;
  width: 100%;
}

.helpers__formItem___H3t8g {
  display: block;
  margin-bottom: 20px;

  input,
  select {
    min-width: 12em;
  }

  &:last-child {
    margin-bottom: 0;
  }
}

.helpers__formItemMono___o_E1Y {

  input {
    font-family: MaisonMono, monospace;
    width: 12em;
  }

  label {
    display: block;
  }
}

.helpers__formItemHalf___iLkj1 {

  input,
  select {
    lost-column: 1 / 2;

    @media (max-width: 960px) {
      lost-column: 1 / 1;
    }
  }
}

.helpers__formItemQuarter___Cy507 {

  input,
  select {
    lost-column: 1/4;

    @media (max-width: 960px) {
      lost-column: 1/2;
    }
  }
}

.helpers__formLabel___cG4c3 {
  display: block;
  margin-bottom: 8px;
}

.helpers__status___LOUFq {
  border-radius: 100px;
  color: white;
  display: inline-block;
  font-size: 10px;
  line-height: 26px;
  padding: 0 10px;
  text-align: center;
  text-transform: capitalize;
  width: auto;
}

.helpers__statusActive___KllDq {
  background: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGreen"]};
  color: #e4faf7;
}

.helpers__statusPending___kEme3 {
  background: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtYellow"]};
  color: #797539;
}

.helpers__statusRejected___Aw4OR {
  background: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtRed"]};
  color: #fecad0;
}

.helpers__textarea___dTQ_B {
  background-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGray"]};
  border: 1px solid ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGray"]};
  border-radius: 3px;
  max-width: 100%;
  padding: 7px 0.75rem;
  width: 100%;

  &::placeholder {
    opacity: 0.5;
    font-size: 12px;
  }

  &:focus {
    background: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtBlueLight"]};
    border: 1px solid ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtBlue"]};
    outline: none;
  }
  &:disabled {
    color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGrayDark"]} !important;
    background-color: #e1e1e178;
    font-weight: 600;
    opacity: 0.75;
  }
}

.helpers__titleWrapper___xPWQl {
  margin-bottom: 20px;
  width: 100%;
}

.helpers__title___ljmZl {
  margin: 0;
}

.helpers__searchWrap___m4xNG {
  align-items: center;
  display: flex;
  justify-content: flex-start;
}

.helpers__search___qykvm {
  margin-bottom: 0;
  margin-right: 20px;
  width: 340px;

  label {
    display: none;
  }

  input {
    border: none;
  }
}

.helpers__mono___g1NMy {
  font-family: MaisonMono, monospace;
}

.helpers__removeButton___SsssL {
  background-color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGray"]};
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  background-position: center;
  background-repeat: no-repeat;
  background-size: 15px;
  border-radius: 3px;
  box-shadow: none;
  cursor: pointer;
  display: inline-block;
  height: 30px;
  margin-right: 20px;
  transition: all 0.25s;
  width: 30px;

  &:hover {
    background-color: #e1dfe1;
    box-shadow: none;
  }
}

.helpers__buttons___mUyDm {
  display: flex;
  justify-content: flex-end;
}

.helpers__localHeader___K0rju {
  background: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtBlueLight"]};
  border-bottom: 1px solid ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGray"]};
  border-top: 1px solid ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGray"]};
  padding: 10px 0;
  z-index: 2;
}

.helpers__localHeaderInner___nMyIR {
  display: flex;
  justify-content: space-between;
  padding-bottom: 0;
  padding-top: 0;

  h5 {
    color: ${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtBlueDark"]};
  }

  &:before {
    display: none;
  }
}

.helpers__bodyLeft___CYTcj {
  lost-column: 12/18;

  &:last-child {
    lost-column: 1/1;
  }

  @media (max-width: 1000px) {
    lost-column: 3/5;
  }

  @media (max-width: 768px) {
    lost-column: 1 / 1;
  }

  h2 {
    margin-bottom: 20px;
  }
}

.helpers__bodyLeftAlt___IjadX {
  lost-column: 2/5;

  /* &:last-child {
    lost-column: 1/1;
  } */

  @media (max-width: 1000px) {
    lost-column: 3/5;
  }

  @media (max-width: 768px) {
    lost-column: 1 / 1;
  }

  h2 {
    margin-bottom: 20px;
  }
}

.helpers__bodyRight___dXDnt {
  lost-column: 6/18;

  @media (max-width: 1000px) {
    lost-column: 2/5;
  }

  @media (max-width: 768px) {
    lost-column: 1 / 1;
    margin-top: 20px;
  }
}

.helpers__bodyRightAlt___pGUA1 {
  lost-column: 3/5;

  @media (max-width: 1000px) {
    lost-column: 2/5;
  }

  @media (max-width: 768px) {
    lost-column: 1 / 1;
    margin-top: 20px;
  }
}

/* expand/close styles */

.helpers__collapseIcon___MAgGr {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  background-position: center;
  background-repeat: no-repeat;
  background-size: 16px;
  display: inline-block;
  height: 48px;
  width: 48px;
  transition: transform 0.25s;
}

.helpers__collapseRef___iUjgD {
  margin-bottom: 20px;
  width: 100%;

  &[data-active='true'] {
    .helpers__collapseIcon___MAgGr {
      transform: rotate(180deg);
    }
  }
}

.helpers__dropdownArea___CN1Vk {
  display: flex;
  align-items: center;
  justify-content: center;
  text-transform: uppercase;
  cursor: pointer;
  height: 48px;
  transition: opacity 0.2s;

  &:hover {
    opacity: 0.8;
  }
}

.helpers__toggleLabel___rJqca {
  font-weight: 500;
  line-height: 48px;
  font-size: 13px;
  color: #9b9b9b;
}

/* notes wrapper */

.helpers__noteWrapper___q5kWC {
  display: flex;
  flex-direction: column;
  padding: 10px 15px;
  margin-bottom: 1px;
  width: 100%;
}

/* flex classes */

.helpers__flexRow___p7VUc {
  align-items: center;
  display: flex;
  flex: 1;
  flex-direction: row;
  width: 100%;
}

.helpers__flexColumn___X77rv {
  display: flex;
  flex-direction: column;
}

.helpers__flexSB___b4G5A {
  display: flex;
  justify-content: space-between;
  width: 100%;
}

/* page */

.helpers__pageTitle___ojU3p {
  font-weight: 400;
}

/* designed to be used together */

.helpers__pageTitleWithInfo___ll0q1 {
  font-weight: 400;
  margin-bottom: 10px;
}

.helpers__infoText___TqCMm {
  font-size: 15px;
  line-height: 1.4;
  margin: 0 0 20px;
  max-width: 600px;
  width: 100%;
}

/* sidebar vert offset */

.helpers__topPageMargin___S6r4n {
  margin-top: 72px;
}

.helpers__serif___mqpJQ {
  font-family: serif !important;
  color: #3b3b3b !important;
}
`, "",{"version":3,"sources":["webpack://./universal/styles/helpers.css"],"names":[],"mappings":"AAGA;EACE,8BAA8B;EAC9B,kBAAkB;;EAElB;IACE,cAAc;EAChB;AACF;;AAEA;EACE,wCAAwC;EACxC,kBAAkB;EAClB,8CAA8C;AAChD;;AAEA;EAEE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,8DAAwB;EACxB,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,gBAAgB;;EAEhB;IACE,YAAY;EACd;;EAEA;IACE,wDAAuB;IACvB,8DAAwB;IACxB,aAAa;EACf;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,oDAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,uBAAuB;EACvB,yDAAiD;EACjD,sCAAsC;EACtC,4BAA4B;EAC5B,8DAAwB;EACxB,kBAAkB;EAClB,mDAAa;EACb,eAAe;EACf,qBAAqB;EACrB,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,gBAAgB;;EAEhB;IACE,8DAA6B;IAC7B,8DAAwB;IACxB,aAAa;EACf;;EAEA;IACE,kCAAkC;EACpC;;EAEA;;IAEE,+DAAsB;IACtB,gBAAgB;EAClB;EACA;IACE,mBAAmB;IACnB,8DAA4B;IAC5B,gCAAgC;IAChC,2CAA2C;EAC7C;AACF;;AAEA;EACE,WAAW;EACX,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,wBAAwB;EACxB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,wBAAwB;EACxB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,wBAAwB;EACxB,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,YAAY;;AAEZ;EACE,wDAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,iBAAiB;EACjB,qBAAqB;EACrB,WAAW;;EAEX;IACE,YAAY;;IAEZ;MACE,YAAY;IACd;EACF;;EAEA;IACE,wDAAsB;IACtB,gBAAgB;EAClB;;EAEA;;IAEE,wDAAsB;IACtB,YAAY;EACd;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA;EACE,wDAAkB;EAClB,mDAAa;EAEb,uBAAuB;EACvB,oBAAoB;;EAEpB;IACE,mBAAmB;EACrB;;EAEA;;IAEE,mBAAmB;EACrB;AACF;;AAEA;EACE,wDAAiB;;EAGjB;;;IAGE,wDAAqB;EACvB;AACF;;AAEA;EACE,mDAAc;EAEd,yBAAyB;AAC3B;;AAEA;EACE,wDAAmB;EACnB,YAAY;AAEd;;AAEA;EACE,mDAAc;EACd,eAAe;EACf,qBAAqB;EACrB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,8DAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,2BAA2B;;EAE3B;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,wCAAwC;EACxC,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;EACZ,qBAAqB;EACrB,oDAAgB;;EAEhB;IACE,mBAAmB;IACnB,wCAAwC;EAC1C;AACF;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA,mBAAmB;;AAEnB;;EAEE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,mDAAY;AACd;;AAEA;EACE,mDAAY;EAEZ,mBAAmB;;EAEnB;;IAEE,mDAAY;EACd;AACF;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,yDAA0B;EAC1B,0BAA0B;EAC1B,2CAA2C;EAC3C,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;;AAEA;EACE,2BAA2B;EAC3B,WAAW;AACb;;AAEA;EAEE,cAAc;EACd,mBAAmB;;EAEnB;;IAEE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA;;EAGE;IACE,kCAAkC;IAClC,WAAW;EACb;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA;;EAGE;;IAEE,kBAAkB;;IAElB;MACE,kBAAkB;IACpB;EACF;AACF;;AAEA;;EAGE;;IAEE,gBAAgB;;IAEhB;MACE,gBAAgB;IAClB;EACF;AACF;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,YAAY;EACZ,qBAAqB;EACrB,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,0BAA0B;EAC1B,WAAW;AACb;;AAEA;EACE,wDAAmB;EACnB,cAAc;AAEhB;;AAEA;EACE,yDAAoB;EACpB,cAAc;AAEhB;;AAEA;EACE,wDAAiB;EACjB,cAAc;AAEhB;;AAEA;EACE,8DAAwB;EACxB,8DAAwB;EACxB,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,WAAW;;EAEX;IACE,YAAY;IACZ,eAAe;EACjB;;EAEA;IACE,wDAAuB;IACvB,8DAAwB;IACxB,aAAa;EACf;EACA;IACE,8DAA4B;IAC5B,2BAA2B;IAC3B,gBAAgB;IAChB,aAAa;EACf;AACF;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EAEE,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;;EAEZ;IACE,aAAa;EACf;;EAEA;IACE,YAAY;EACd;AACF;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,8DAAwB;EACxB,yDAAmD;EACnD,2BAA2B;EAC3B,4BAA4B;EAC5B,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;;EAEX;IACE,yBAAyB;IACzB,gBAAgB;EAClB;AACF;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,wDAAuB;EACvB,qEAA+B;EAC/B,kEAA4B;EAC5B,eAAe;EACf,UAAU;AACZ;;AAEA;EAEE,aAAa;EACb,8BAA8B;EAC9B,iBAAiB;EACjB,cAAc;;EAEd;IACE,mDAAiB;EACnB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;EACE,kBAAkB;;EAElB;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,gBAAgB;;EAEhB;;KAEG;;EAEH;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA;EACE,iBAAiB;;EAEjB;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;AACF;;AAEA;EACE,gBAAgB;;EAEhB;IACE,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;AACF;;AAEA,wBAAwB;;AAExB;EACE,yDAAgD;EAChD,2BAA2B;EAC3B,4BAA4B;EAC5B,qBAAqB;EACrB,qBAAqB;EACrB,YAAY;EACZ,WAAW;EACX,2BAA2B;AAC7B;;AAEA;EAEE,mBAAmB;EACnB,WAAW;;EAEX;IACE;MACE,yBAAyB;IAC3B;EACF;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,eAAe;EACf,YAAY;EACZ,wBAAwB;;EAExB;IACE,YAAY;EACd;AACF;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,cAAc;AAChB;;AAEA,kBAAkB;;AAElB;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;AACb;;AAEA,iBAAiB;;AAEjB;EACE,mBAAmB;EACnB,aAAa;EACb,OAAO;EACP,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;AACb;;AAEA,SAAS;;AAET;EACE,gBAAgB;AAClB;;AAEA,iCAAiC;;AAEjC;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;AACb;;AAEA,wBAAwB;;AAExB;EACE,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,yBAAyB;AAC3B","sourcesContent":["@value colors: 'styles/colors.css';\n@value gtGreen, gtRed, gtRedDark, gtYellow, gtGray, gtGrayDark, gtBlue, gtBlueDark, gtBlueLight, gtGreenLight, gtYellow, gtYellowLight, gtYellowDark, text, textLight, gtCardHeaderBG, borderColor from colors;\n\n.errorWrapper {\n  border-left: 3px solid #a13739;\n  padding-left: 10px;\n\n  label {\n    color: #a13739;\n  }\n}\n\n.card {\n  border: 1px solid rgba(73, 80, 84, 0.15);\n  border-radius: 4px;\n  box-shadow: 0 1px 2px 0 rgba(58, 64, 68, 0.08);\n}\n\n.cardMarginBot {\n  composes: card;\n  margin-bottom: 20px;\n}\n\n.input {\n  background: white;\n  border: 1px solid gtGray;\n  border-radius: 3px;\n  height: 42px;\n  line-height: 42px;\n  padding: 0 0.75rem;\n  transition: all 0.25s;\n  width: 100%;\n  font-weight: 500;\n\n  &::placeholder {\n    opacity: 0.5;\n  }\n\n  &:focus {\n    background: gtBlueLight;\n    border: 1px solid gtBlue;\n    outline: none;\n  }\n\n  &:not(:placeholder-shown) {\n    font-weight: 700;\n  }\n}\n\n.label {\n  color: textLight;\n  cursor: pointer;\n  display: inline-block;\n  font-size: 12px;\n  margin-bottom: 3px;\n}\n\n.select {\n  -webkit-appearance: none;\n  background-color: white;\n  background-image: url('styles/img/icon_down.png');\n  background-position: right 15px center;\n  background-repeat: no-repeat;\n  border: 1px solid gtGray;\n  border-radius: 3px;\n  color: gtBlue;\n  cursor: pointer;\n  display: inline-block;\n  height: 42px;\n  padding: 0 0.75rem;\n  width: 100%;\n  font-weight: 500;\n\n  &:focus {\n    background-color: gtBlueLight;\n    border: 1px solid gtBlue;\n    outline: none;\n  }\n\n  &:not(:focus) {\n    background-color: white !important;\n  }\n\n  &:has(option:checked:not([value])),\n  &:has(option:checked:not([value=''])) {\n    color: text !important;\n    font-weight: 700;\n  }\n  &:disabled {\n    cursor: not-allowed;\n    color: gtGrayDark !important;\n    background: #e1e1e178 !important;\n    border: 1px solid rgba(195, 195, 195, 0.45);\n  }\n}\n\n.clearfix::after {\n  clear: both;\n  content: '';\n  display: table;\n}\n\n.content-container {\n  lost-center: 1440px 20px;\n  padding: 20px;\n}\n\n.row {\n  align-items: center;\n  float: none;\n  lost-flex-container: row;\n  lost-utility: clearfix;\n}\n\n.rowTop {\n  float: none;\n  lost-flex-container: row;\n  lost-utility: clearfix;\n}\n\n.halfLeft {\n  justify-content: flex-start;\n  lost-column: 1/2;\n  text-align: left;\n}\n\n.halfRight {\n  justify-content: flex-end;\n  lost-column: 1/2;\n  text-align: right;\n}\n\n/* Buttons */\n\n.button {\n  background: gtBlue;\n  border: none;\n  border-radius: 3px;\n  box-shadow: none;\n  color: white;\n  cursor: pointer;\n  display: inline-block;\n  font-size: 15px;\n  font-weight: 700;\n  height: 48px;\n  line-height: 48px;\n  padding: 0 1.5em;\n  text-decoration: none;\n  text-shadow: none;\n  transition: all 0.25s;\n  width: auto;\n\n  &:disabled {\n    opacity: 0.4;\n\n    &:hover {\n      opacity: 0.4;\n    }\n  }\n\n  &:hover {\n    background: gtBlueDark;\n    box-shadow: none;\n  }\n\n  &:active,\n  &:focus {\n    background: gtBlueDark;\n    border: none;\n  }\n\n  &:first-child {\n    margin-left: 0;\n  }\n}\n\n.buttonSecondary {\n  background: gtGray;\n  color: gtBlue;\n  composes: button;\n  /* padding-top: 12px; */\n  padding-bottom: 12px;\n\n  &:hover {\n    background: #e1dfe1;\n  }\n\n  &:active,\n  &:focus {\n    background: #e1dfe1;\n  }\n}\n\n.buttonDanger {\n  background: gtRed;\n  composes: button;\n\n  &:active,\n  &:focus,\n  &:hover {\n    background: gtRedDark;\n  }\n}\n\n.buttonLocal {\n  color: gtGreen;\n  composes: buttonSecondary;\n  padding-top: 0 !important;\n}\n\n.buttonLocalActive {\n  background: gtGreen;\n  color: white;\n  composes: buttonLocal;\n}\n\n.addButton {\n  color: gtGreen;\n  cursor: pointer;\n  display: inline-block;\n  background: none;\n  font-weight: 600;\n  border-radius: 3px;\n  padding: 0 1.5em;\n  border: 2px solid gtGreen;\n  height: 42px;\n  line-height: 38px;\n  transition: background 0.2s;\n\n  &:hover {\n    background: #f8f8f8;\n  }\n}\n\n.dropzoneArea {\n  cursor: pointer;\n  background: none;\n  width: 100%;\n  font-weight: 500;\n  border: 2px dashed rgba(58, 64, 68, 0.2);\n  border-radius: 3px;\n  text-align: center;\n  line-height: 80px;\n  height: 80px;\n  transition: all 0.25s;\n  color: textLight;\n\n  &:hover {\n    background: #f8f8f8;\n    border: 2px dashed rgba(58, 64, 68, 0.4);\n  }\n}\n\n.docLink {\n  margin-left: 32px;\n  position: relative;\n}\n\n/* Section styles */\n\n.boxWrap,\n.section {\n  background: white;\n  border-radius: 3px;\n  margin: 0 0 20px;\n  padding: 20px;\n  width: 100%;\n}\n\n.sectionNoMargin {\n  background: white;\n  border-radius: 3px;\n  padding: 20px;\n  width: 100%;\n}\n\n.sectionSmall {\n  background: white;\n  border-radius: 3px;\n  margin-bottom: 1px;\n  padding: 20px;\n  width: 100%;\n}\n\n.errorText {\n  color: gtRed;\n}\n\n.errors {\n  color: gtRed;\n  composes: sectionSmall;\n  margin-bottom: 20px;\n\n  h5,\n  h6 {\n    color: gtRed;\n  }\n}\n\n.sectionLarge {\n  background: white;\n  border-radius: 3px;\n  margin-bottom: 40px;\n  padding: 20px;\n  width: 100%;\n}\n\n.sectionTitle {\n  align-items: center;\n  background: gtCardHeaderBG;\n  border-radius: 4px 4px 0 0;\n  box-shadow: 0 1px 0 0 rgba(58, 64, 68, 0.1);\n  display: flex;\n  height: 50px;\n  margin-bottom: 1px;\n  padding: 0 20px;\n  width: 100%;\n}\n\n.form {\n  lost-flex-container: column;\n  width: 100%;\n}\n\n.formItem {\n  composes: clearfix;\n  display: block;\n  margin-bottom: 20px;\n\n  input,\n  select {\n    min-width: 12em;\n  }\n\n  &:last-child {\n    margin-bottom: 0;\n  }\n}\n\n.formItemMono {\n  composes: formItem;\n\n  input {\n    font-family: MaisonMono, monospace;\n    width: 12em;\n  }\n\n  label {\n    display: block;\n  }\n}\n\n.formItemHalf {\n  composes: formItem;\n\n  input,\n  select {\n    lost-column: 1 / 2;\n\n    @media (max-width: 960px) {\n      lost-column: 1 / 1;\n    }\n  }\n}\n\n.formItemQuarter {\n  composes: formItem;\n\n  input,\n  select {\n    lost-column: 1/4;\n\n    @media (max-width: 960px) {\n      lost-column: 1/2;\n    }\n  }\n}\n\n.formLabel {\n  display: block;\n  margin-bottom: 8px;\n}\n\n.status {\n  border-radius: 100px;\n  color: white;\n  display: inline-block;\n  font-size: 10px;\n  line-height: 26px;\n  padding: 0 10px;\n  text-align: center;\n  text-transform: capitalize;\n  width: auto;\n}\n\n.statusActive {\n  background: gtGreen;\n  color: #e4faf7;\n  composes: status;\n}\n\n.statusPending {\n  background: gtYellow;\n  color: #797539;\n  composes: status;\n}\n\n.statusRejected {\n  background: gtRed;\n  color: #fecad0;\n  composes: status;\n}\n\n.textarea {\n  background-color: gtGray;\n  border: 1px solid gtGray;\n  border-radius: 3px;\n  max-width: 100%;\n  padding: 7px 0.75rem;\n  width: 100%;\n\n  &::placeholder {\n    opacity: 0.5;\n    font-size: 12px;\n  }\n\n  &:focus {\n    background: gtBlueLight;\n    border: 1px solid gtBlue;\n    outline: none;\n  }\n  &:disabled {\n    color: gtGrayDark !important;\n    background-color: #e1e1e178;\n    font-weight: 600;\n    opacity: 0.75;\n  }\n}\n\n.titleWrapper {\n  margin-bottom: 20px;\n  width: 100%;\n}\n\n.title {\n  margin: 0;\n}\n\n.searchWrap {\n  align-items: center;\n  display: flex;\n  justify-content: flex-start;\n}\n\n.search {\n  composes: card;\n  margin-bottom: 0;\n  margin-right: 20px;\n  width: 340px;\n\n  label {\n    display: none;\n  }\n\n  input {\n    border: none;\n  }\n}\n\n.mono {\n  font-family: MaisonMono, monospace;\n}\n\n.removeButton {\n  background-color: gtGray;\n  background-image: url('styles/img/icon_remove.png');\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: 15px;\n  border-radius: 3px;\n  box-shadow: none;\n  cursor: pointer;\n  display: inline-block;\n  height: 30px;\n  margin-right: 20px;\n  transition: all 0.25s;\n  width: 30px;\n\n  &:hover {\n    background-color: #e1dfe1;\n    box-shadow: none;\n  }\n}\n\n.buttons {\n  display: flex;\n  justify-content: flex-end;\n}\n\n.localHeader {\n  background: gtBlueLight;\n  border-bottom: 1px solid gtGray;\n  border-top: 1px solid gtGray;\n  padding: 10px 0;\n  z-index: 2;\n}\n\n.localHeaderInner {\n  composes: content-container;\n  display: flex;\n  justify-content: space-between;\n  padding-bottom: 0;\n  padding-top: 0;\n\n  h5 {\n    color: gtBlueDark;\n  }\n\n  &:before {\n    display: none;\n  }\n}\n\n.bodyLeft {\n  lost-column: 12/18;\n\n  &:last-child {\n    lost-column: 1/1;\n  }\n\n  @media (max-width: 1000px) {\n    lost-column: 3/5;\n  }\n\n  @media (max-width: 768px) {\n    lost-column: 1 / 1;\n  }\n\n  h2 {\n    margin-bottom: 20px;\n  }\n}\n\n.bodyLeftAlt {\n  lost-column: 2/5;\n\n  /* &:last-child {\n    lost-column: 1/1;\n  } */\n\n  @media (max-width: 1000px) {\n    lost-column: 3/5;\n  }\n\n  @media (max-width: 768px) {\n    lost-column: 1 / 1;\n  }\n\n  h2 {\n    margin-bottom: 20px;\n  }\n}\n\n.bodyRight {\n  lost-column: 6/18;\n\n  @media (max-width: 1000px) {\n    lost-column: 2/5;\n  }\n\n  @media (max-width: 768px) {\n    lost-column: 1 / 1;\n    margin-top: 20px;\n  }\n}\n\n.bodyRightAlt {\n  lost-column: 3/5;\n\n  @media (max-width: 1000px) {\n    lost-column: 2/5;\n  }\n\n  @media (max-width: 768px) {\n    lost-column: 1 / 1;\n    margin-top: 20px;\n  }\n}\n\n/* expand/close styles */\n\n.collapseIcon {\n  background-image: url('styles/img/dropdown.png');\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: 16px;\n  display: inline-block;\n  height: 48px;\n  width: 48px;\n  transition: transform 0.25s;\n}\n\n.collapseRef {\n  composes: card;\n  margin-bottom: 20px;\n  width: 100%;\n\n  &[data-active='true'] {\n    .collapseIcon {\n      transform: rotate(180deg);\n    }\n  }\n}\n\n.dropdownArea {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  text-transform: uppercase;\n  cursor: pointer;\n  height: 48px;\n  transition: opacity 0.2s;\n\n  &:hover {\n    opacity: 0.8;\n  }\n}\n\n.toggleLabel {\n  font-weight: 500;\n  line-height: 48px;\n  font-size: 13px;\n  color: #9b9b9b;\n}\n\n/* notes wrapper */\n\n.noteWrapper {\n  display: flex;\n  flex-direction: column;\n  padding: 10px 15px;\n  margin-bottom: 1px;\n  width: 100%;\n}\n\n/* flex classes */\n\n.flexRow {\n  align-items: center;\n  display: flex;\n  flex: 1;\n  flex-direction: row;\n  width: 100%;\n}\n\n.flexColumn {\n  display: flex;\n  flex-direction: column;\n}\n\n.flexSB {\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n}\n\n/* page */\n\n.pageTitle {\n  font-weight: 400;\n}\n\n/* designed to be used together */\n\n.pageTitleWithInfo {\n  font-weight: 400;\n  margin-bottom: 10px;\n}\n\n.infoText {\n  font-size: 15px;\n  line-height: 1.4;\n  margin: 0 0 20px;\n  max-width: 600px;\n  width: 100%;\n}\n\n/* sidebar vert offset */\n\n.topPageMargin {\n  margin-top: 72px;\n}\n\n.serif {\n  font-family: serif !important;\n  color: #3b3b3b !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"colors": `'styles/colors.css'`,
	"gtGreen": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGreen"]}`,
	"gtRed": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtRed"]}`,
	"gtRedDark": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtRedDark"]}`,
	"gtYellow": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtYellow"]}`,
	"gtGray": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGray"]}`,
	"gtGrayDark": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGrayDark"]}`,
	"gtBlue": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtBlue"]}`,
	"gtBlueDark": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtBlueDark"]}`,
	"gtBlueLight": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtBlueLight"]}`,
	"gtGreenLight": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtGreenLight"]}`,
	"gtYellowLight": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtYellowLight"]}`,
	"gtYellowDark": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtYellowDark"]}`,
	"text": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["text"]}`,
	"textLight": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["textLight"]}`,
	"gtCardHeaderBG": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["gtCardHeaderBG"]}`,
	"borderColor": `${___CSS_LOADER_ICSS_IMPORT_0___.locals["borderColor"]}`,
	"errorWrapper": `helpers__errorWrapper___YO9B9`,
	"card": `helpers__card___Gg3yG`,
	"cardMarginBot": `helpers__cardMarginBot___X0aML helpers__card___Gg3yG`,
	"input": `helpers__input___Qys3C`,
	"label": `helpers__label___cektH`,
	"select": `helpers__select___atjcE`,
	"clearfix": `helpers__clearfix___NGtVZ`,
	"content-container": `helpers__content-container___ib8em`,
	"row": `helpers__row___plfhc`,
	"rowTop": `helpers__rowTop____WU6A`,
	"halfLeft": `helpers__halfLeft___v4YHP`,
	"halfRight": `helpers__halfRight___qgGju`,
	"button": `helpers__button___UMeeN`,
	"buttonSecondary": `helpers__buttonSecondary___ji2f0 helpers__button___UMeeN`,
	"buttonDanger": `helpers__buttonDanger___rKFYv helpers__button___UMeeN`,
	"buttonLocal": `helpers__buttonLocal___p_fq2 helpers__buttonSecondary___ji2f0 helpers__button___UMeeN`,
	"buttonLocalActive": `helpers__buttonLocalActive___S9s2m helpers__buttonLocal___p_fq2 helpers__buttonSecondary___ji2f0 helpers__button___UMeeN`,
	"addButton": `helpers__addButton___qCRqP`,
	"dropzoneArea": `helpers__dropzoneArea___G6f3s`,
	"docLink": `helpers__docLink___FASgd`,
	"boxWrap": `helpers__boxWrap___tA8T7`,
	"section": `helpers__section___r3JJf`,
	"sectionNoMargin": `helpers__sectionNoMargin___JiDIG`,
	"sectionSmall": `helpers__sectionSmall___nou05`,
	"errorText": `helpers__errorText___iCO0x`,
	"errors": `helpers__errors____e8HD helpers__sectionSmall___nou05`,
	"sectionLarge": `helpers__sectionLarge___tGucQ`,
	"sectionTitle": `helpers__sectionTitle___pCNpO`,
	"form": `helpers__form___SDgsR`,
	"formItem": `helpers__formItem___H3t8g helpers__clearfix___NGtVZ`,
	"formItemMono": `helpers__formItemMono___o_E1Y helpers__formItem___H3t8g helpers__clearfix___NGtVZ`,
	"formItemHalf": `helpers__formItemHalf___iLkj1 helpers__formItem___H3t8g helpers__clearfix___NGtVZ`,
	"formItemQuarter": `helpers__formItemQuarter___Cy507 helpers__formItem___H3t8g helpers__clearfix___NGtVZ`,
	"formLabel": `helpers__formLabel___cG4c3`,
	"status": `helpers__status___LOUFq`,
	"statusActive": `helpers__statusActive___KllDq helpers__status___LOUFq`,
	"statusPending": `helpers__statusPending___kEme3 helpers__status___LOUFq`,
	"statusRejected": `helpers__statusRejected___Aw4OR helpers__status___LOUFq`,
	"textarea": `helpers__textarea___dTQ_B`,
	"titleWrapper": `helpers__titleWrapper___xPWQl`,
	"title": `helpers__title___ljmZl`,
	"searchWrap": `helpers__searchWrap___m4xNG`,
	"search": `helpers__search___qykvm helpers__card___Gg3yG`,
	"mono": `helpers__mono___g1NMy`,
	"removeButton": `helpers__removeButton___SsssL`,
	"buttons": `helpers__buttons___mUyDm`,
	"localHeader": `helpers__localHeader___K0rju`,
	"localHeaderInner": `helpers__localHeaderInner___nMyIR helpers__content-container___ib8em`,
	"bodyLeft": `helpers__bodyLeft___CYTcj`,
	"bodyLeftAlt": `helpers__bodyLeftAlt___IjadX`,
	"bodyRight": `helpers__bodyRight___dXDnt`,
	"bodyRightAlt": `helpers__bodyRightAlt___pGUA1`,
	"collapseIcon": `helpers__collapseIcon___MAgGr`,
	"collapseRef": `helpers__collapseRef___iUjgD helpers__card___Gg3yG`,
	"dropdownArea": `helpers__dropdownArea___CN1Vk`,
	"toggleLabel": `helpers__toggleLabel___rJqca`,
	"noteWrapper": `helpers__noteWrapper___q5kWC`,
	"flexRow": `helpers__flexRow___p7VUc`,
	"flexColumn": `helpers__flexColumn___X77rv`,
	"flexSB": `helpers__flexSB___b4G5A`,
	"pageTitle": `helpers__pageTitle___ojU3p`,
	"pageTitleWithInfo": `helpers__pageTitleWithInfo___ll0q1`,
	"infoText": `helpers__infoText___TqCMm`,
	"topPageMargin": `helpers__topPageMargin___S6r4n`,
	"serif": `helpers__serif___mqpJQ`
};
export default ___CSS_LOADER_EXPORT___;
